const CRM_ALLOWED_ROLES = new Set(['owner', 'founder', 'admin']);

export function getActiveCrmRole() {
  const role = typeof window !== 'undefined'
    ? (window._currentRole || window._authenticatedRole || window._currentUser?.role || '')
    : '';
  return String(role || '').trim().toLowerCase();
}

export function canAccessCrm() {
  return CRM_ALLOWED_ROLES.has(getActiveCrmRole());
}

export function assertCrmAccess() {
  if (!canAccessCrm()) throw new Error('Sem permissão para acessar o CRM');
}

